// @flow
import * as React from 'react'
import { Row, Col } from 'react-awesome-styled-grid'
import SectionTitle from '@components/blog/SectionTitle'
import type { BlogPostType } from '../../services/contentfulPosts'
import BlogSummary from '@components/blog/BlogSummary'
import { colors } from '@components/shared/colors'
import styled from 'styled-components'
import { CTASecondary } from '@components/shared/buttons'

type PropsType = {
  blogs: BlogPostType[],
  readMore: (skip: number) => Promise<void>
}

export default function LatestBlogs (props: PropsType): React.Node {
  const blogPostCount = props.blogs.length
  return (
    <Row>
      <Col xs={4} sm={8} lg={10} offset={{
        lg: 1,
        xl: 1
      }}>
        <SectionTitle title={'The Latest'}/>
      </Col>
      <Col xs={4} sm={8} lg={10} offset={{
        lg: 1,
        xl: 1
      }}>
        {props.blogs.map((blog: BlogPostType, index: number): React.Node => {
          return (<BlogSummary blog={blog} key={`latest-${blog.id}-index`} />)
        })}
        <ReadMoreButtonContainer>
          <CTASecondary onClick={(): Promise<void> => props.readMore(blogPostCount)} color={colors.sand}>
            Read More
          </CTASecondary>
        </ReadMoreButtonContainer>
      </Col>
    </Row>
  )
}

const ReadMoreButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 140px;
`
